import { Injectable } from "@angular/core";
import * as moment from "moment";
import { localDateFormat } from "../global/date-format";
import { featureValuesAsArray, isLensOrderItem, LensOrderItem, OrderItem } from "../model/order/order";
import { CatalogService } from "../utils/catalog.service";
import { LanguagePickerService } from "../utils/language-picker/language-picker.service";
import { GlobalStorageService } from "./global-storage.service";

@Injectable()
export class i18nService {

  constructor(private languagePickerService: LanguagePickerService,
              private catalogService: CatalogService,
              private globalStorageService: GlobalStorageService) {}

  toDateString(date: Date): string {
    return date && moment(date).format(localDateFormat);
  }

  getLimitsFormatted(rangeMin: number, rangeMax: number, ) {
    return {
      rangeMin: rangeMin,
      rangeMax: rangeMax
    }
  }

  formatIfNumber(val: any, digits?: number): any {
    return this.isNumber(val) ? this.formatDecimal(this.parseNumber(val), digits) : val;
  }

  isNumber(num: any): boolean {
    return !isNaN(this.parseNumber(num))
  }

  parseNumber(num: any): number {
    if(typeof num === "string")
      return num && Number(num.replace(',', '.'));
    else if (typeof num === "number")
      return num;
    else if (num == null)
      return null;
    else
      return NaN;
  }

  formatDecimal(num: number, digits?: number): string {
    if (num != null)
    return num.toLocaleString(this.languagePickerService.getLanguageCode(), {minimumFractionDigits: digits});
  }

  getLensesDescriptionOverview(item: OrderItem): string {
    if(isLensOrderItem(item)) {
      let description = `${item.article?.name}, ${item.article?.backSide?.name}`;
      if(item.material?.name) {
        description += `, ${item.material?.name}`
      }
      if(item.color?.name) {
        description += `, ${item.color?.name}`;
      }
      description += "\n";
      if(item && item.featureValues) {
        featureValuesAsArray(item.featureValues).forEach(feature => {
          if(feature.value) {
            this.catalogService.getFeatureTranslation(feature.name).subscribe(translation => {
              if(Number.isNaN(+feature.value)) {
                description += `${translation}: ${feature.value}, `;
              } else {
                description += `${translation}: ${this.formatIfNumber(+feature.value, this.getDecimalFormat(item, feature.name))}, `;
              }
            })
          }
        })
      }
      description = description.substring(0, description.length - 2);
      return description;
    }
    return item.article?.name;
  }

  getLensesDescriptionOrderConfirm(item: LensOrderItem): string {
    let description = `${item.material?.name}, ${item.color?.name}`+"\n";
    if(item && item.featureValues) {
      featureValuesAsArray(item.featureValues).forEach(feature => {
        if(feature.value) {
          this.catalogService.getFeatureTranslation(feature.name).subscribe(translation => {
            if(Number.isNaN(+feature.value)) {
              description += `${translation}: ${feature.value}, `;
            } else {
              description += `${translation}: ${this.formatIfNumber(+feature.value, this.getDecimalFormat(item, feature.name))}, `;
              }
            })
          }
        })
    }
    description = description.substring(0, description.length - 2);
    return description;
  }

  getDecimalFormat(item: LensOrderItem, name: string): number {
    if(item.decimalFormats) {
      return item.decimalFormats[name];
    } else if(this.globalStorageService.decimalFormats) {
      return this.globalStorageService.decimalFormats.find(feature => feature.featureName === name)?.decimalFormat;
    }
  }

  replaceFromDotToComma(value: number): any {
    if (value != null)
    return value.toString().replace(/\./g, ',');
  }

  replaceFromCommaToDot(value: string): number {
    if (value != null)
    return +(value.toString().replace(/,/g, '.'));
  }
}
